<ng-container *transloco="let t">
    <div class="h-1/3">
        <div class="px-4 sm:px-16 pt-10 pb-10 star-background">
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4">

                <div><img src="assets/icons/custom/star.svg" class="w-24 star" [style]="'animationDuration:3s'"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="flex flex-col">
                    <div class="font-medium text-2xl">{{t(star1?.i18nTitleKey)}}</div>
                    <div class="w-60 max-w-full">{{t(star1?.i18nDescriptionKey)}}</div>
                </div>

                <div></div>
                <div></div>


                <div><img src="assets/icons/custom/star.svg" class="w-24 star" [style]="'animationDuration:2.1s'"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="flex flex-col">
                    <div class="font-medium text-2xl">{{t(star2?.i18nTitleKey)}}</div>
                    <div class="w-60 max-w-full">{{t(star2?.i18nDescriptionKey)}}</div>
                </div>

                <div></div>

                <div><img src="assets/icons/custom/star.svg" class="w-24 star" [style]="'animationDuration:0.8s'"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="flex flex-col">
                    <div class="font-medium text-2xl">{{t(star3?.i18nTitleKey)}}</div>
                    <div class="w-60 max-w-full">{{t(star3?.i18nDescriptionKey)}}</div>
                </div>



                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div><img src="assets/icons/custom/star.svg" class="w-24 star" [style]="'animationDuration:1.1s'"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="flex flex-col">
                    <div class="font-medium text-2xl">{{t(star4?.i18nTitleKey)}}</div>
                    <div class="w-60 max-w-full">{{t(star4?.i18nDescriptionKey)}}</div>
                </div>

                <div></div>
                <div><img src="assets/icons/custom/star.svg" class="w-24 star" [style]="'animationDuration:1.5s'"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="flex flex-col">
                    <div class="font-medium text-2xl">{{t(star5?.i18nTitleKey)}}</div>
                    <div class="w-60 max-w-full">{{t(star5?.i18nDescriptionKey)}}</div>
                </div>


                <div></div>
                <div></div>
                <div><img src="assets/icons/custom/star.svg" class="w-24 star" [style]="'animationDuration:1.5s'"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="flex flex-col">
                    <div class="font-medium text-2xl">{{t(star6?.i18nTitleKey)}}</div>
                    <div class="w-60 max-w-full">{{t(star6?.i18nDescriptionKey)}}</div>
                </div>
            </div>
        </div>
    </div>


</ng-container>
